import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const client = axios.create({ baseURL: API, timeout: 15000 });

export const submitContact = (data) => client.post('/contact', data).then((r) => r.data);
export const getTestimonials = () => client.get('/testimonials').then((r) => r.data);
export const getProjects = () => client.get('/projects').then((r) => r.data);

export default client;
